import { bffRetailMedia } from '~/middlewares/axios'

export const getInvestmentEstimateServiceKey = 'getInvestmentEstimate'

// Named get*, not create*: POST here reads/computes a simulation, it doesn't
// persist anything -- same naming already used by getMinCostService in this
// services layer (also a POST) for the same reason.
export const getInvestmentEstimateService = (body: {
  channel: CampaignChannelValue
  objective: InvestmentObjectiveType
  budget: number
}) =>
  bffRetailMedia.post<InvestmentEstimate>(
    '/campaign/offsite/investment-estimate',
    body
  )
